import * as moment from"moment";

const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm:ss";
export const DATE_INPUT_FORMAT = "DD-MM-YYYY";



export const TRIP_STATUS = {
    IN_PROGRESS: {code: "IN_PROGRESS", label: "In progress"},
    PARTIALLY_COMPLETED: {code: "PARTIALLY_COMPLETED", label: "Partially completed"},
    COMPLETED: {code: "COMPLETED", label: "Completed"},
    CANCELLED: {code: "CANCELLED", label: "Cancelled"},
}

export const formatTripStatus = (tripCode) => {
    if(!tripCode) {
        return "";
    }

    const status = TRIP_STATUS[tripCode];

    return status ? status["label"] : "";
}
export const formatDatetime = datetime => {
    if(!datetime){
        return "";
    }

    return moment.utc(datetime).local().format(DATE_TIME_FORMAT);
}

export const formatDate = date => {
    if(!date) {
        return "";
    }

    return moment(date).format(DATE_INPUT_FORMAT);
}

export const renderLocationAsLink = (location) => {

    if(!location) {
        return;
    }

    return "<a target='_blank' href=\"https://maps.google.com/?q="+(location.latLong?location.latLong: encodeURIComponent(location.streetAddress))+"\">"
     + location.streetAddress+"</a>"
}

//This is just in case want to apply formatting on trip wide
export const formatTrip = trip => {
    if(!trip) {
        return trip;
    }

    return {...trip, status: formatTripStatus(trip['status'])};
}

